import { NPKCatalogs } from "@smartdevis/server/src/domain";

export const formatNPKNumber = (input: string): string => {
    if (input.length <= 3) return input;
    return input.slice(0, 3) + '.' + input.slice(3);
}


// export const setABBNodes = (data: NPKCatalogs.NPKNode) => {
//     function recurse(obj: any): any {
//         if (Array.isArray(obj)) {
//             return obj.map(recurse);
//         }

//         if (obj && typeof obj === 'object') {
//             if (obj.entryStart === -999999999) {
//                 obj.isABB = true;
//                 obj.isSelected = false;
//             }

//             if (obj.subNodes?.npknode) {
//                 obj.subNodes.npknode = obj.subNodes.npknode.map(recurse);
//             }
//         }

//         return obj;
//     }

//     return recurse(data);
// };


export const setABBNodes = (data: NPKCatalogs.NPKNode) => {
    function recurse(obj: NPKCatalogs.NPKNode): any {
        if (Array.isArray(obj)) {
            return obj.map(recurse);
        }

        if (obj && typeof obj === 'object') {
            if (obj.unit) {
                obj.isABB = true;
                obj.isSelected = false;
            }

            if (obj.subNodes?.npknode) {
                obj.subNodes.npknode = obj.subNodes.npknode.map(recurse);
            }
        }

        return obj;
    }

    return recurse(data);
};